/**
 * Created Sprint: Sprint 1 - Monorepo Skeleton
 * Last contract-affecting Sprint: E2EE i18n namespace (`e2ee`)
 * Freeze status: frozen
 * Purpose: Canonical i18n namespace names, kept in shared so web and
 *   future packages use consistent string keys without magic strings.
 */

export const I18N_NS = {
  COMMON: "common",
  AUTH: "auth",
  NOTES: "notes",
  NOTEBOOKS: "notebooks",
  SETTINGS: "settings",
  EDITOR: "editor",
  ERRORS: "errors",
  E2EE: "e2ee",
} as const;

export type I18nNamespace = (typeof I18N_NS)[keyof typeof I18N_NS];
